const validateEmail = (email) => {
  const re = /^[^\s,]+@[^\s,]+\.[^\s,]+$/
  return re.test(email)
}

export default validateEmail
